import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Properties, SMSInfo } from "../../models/polymer/Properties.model";

export interface GenuinePolymerStates {
  properties:Properties[],
  sms_info: SMSInfo
}

const initialState: GenuinePolymerStates = {
  properties: [],
  sms_info: new SMSInfo()
};


const GenuinePolymerSlice = createSlice({
  name:"Genuine Polymer Slice",
  initialState,
  reducers:{
    updateProperties: (state, action: PayloadAction<Properties[]>) => {
      state.properties = action.payload;
    },
    updateSmsInfo: (state, action: PayloadAction<SMSInfo>) => {
      state.sms_info = action.payload;
    },
  },
  extraReducers: (builder) => {}
});


export const { updateProperties, updateSmsInfo } = GenuinePolymerSlice.actions;

export default GenuinePolymerSlice.reducer;


